import dayjs from 'dayjs';

import { Icon, ButtonProps } from 'components';

import { GetButtons } from './types';

export const getButtons = ({
  event,
  hasReview,
  isManager,
  setDailyOpen,
  onEventReview,
  setSummaryOpen,
}: GetButtons) => {
  const buttons: ButtonProps[] = [
    {
      icon: <Icon.Case />,
      text: 'Daily report',
      onClick: () => setDailyOpen(true),
    },
    {
      text: 'Event summary',
      icon: <Icon.Billing />,
      onClick: () => setSummaryOpen(true),
    },
  ];

  const isEndedEvent = dayjs().isAfter(event.endDate, 'day');

  if (isEndedEvent && isManager && !hasReview) {
    buttons.push({
      text: 'Event review',
      onClick: onEventReview,
      icon: <Icon.CheckCircle />,
    });
  }

  return buttons;
};
